import React from 'react';
import styled from 'styled-components';

const IAOfficersInfoModal = ({ officer, onClose, darkMode, onSelect }) => {
  if (!officer) return null;

  const handleEditClick = () => {
    if (typeof onSelect === 'function') {
      onSelect('IAOfficersFormEdit', { officer }); // Pass officer data to edit form
      onClose(); // Automatically close the modal
    } else {
      console.warn('onSelect is not a function. Failed to navigate to IAOfficersFormEdit.');
    }
  };

  return (
    <ModalOverlay>
      <ModalContent darkMode={darkMode}>
        <CloseButton onClick={onClose}>X</CloseButton>
        <TopSection>
          <ImagePlaceholder darkMode={darkMode}>[Image Placeholder]</ImagePlaceholder>
          <OfficerDetails>
            <h2>{officer.first_name} {officer.last_name}</h2>
            <p><strong>Position:</strong> {officer.position}</p>
            <Separator />
            <p><strong>Phone:</strong> {officer.phone_number}</p>
            <p><strong>Email:</strong> {officer.email}</p>
            <EditIcon onClick={handleEditClick}>[✎] Edit</EditIcon>
          </OfficerDetails>
        </TopSection>
        <MottoBox darkMode={darkMode}>{officer.motto}</MottoBox>
      </ModalContent>
    </ModalOverlay>
  );
};

export default IAOfficersInfoModal;

// Styled components for the modal
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  background-color: ${props => props.darkMode ? '#333333' : '#f0f0f0'};
  color: ${props => props.darkMode ? '#ffffff' : '#000000'};
  border: 1px solid ${props => props.darkMode ? '#555555' : '#cccccc'};
  border-radius: 4px;
  padding: 20px;
  position: relative;
  width: 600px;
  max-width: 90%;
  display: flex;
  flex-direction: column;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  &:hover {
    background-color: #1b5e20;
  }
`;

const TopSection = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`;

const ImagePlaceholder = styled.div`
  width: 150px;
  height: 150px;
  background-color: ${props => props.darkMode ? '#555555' : '#e0e0e0'};
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.darkMode ? '#ffffff' : '#000000'};
`;

const OfficerDetails = styled.div`
  flex: 1;
`;

const Separator = styled.div`
  height: 2px;
  background-color: #2e7d32;
  margin: 10px 0;
`;

const MottoBox = styled.div`
  border: 1px solid ${props => props.darkMode ? '#555555' : '#cccccc'};
  padding: 10px;
  background-color: ${props => props.darkMode ? '#444444' : '#ffffff'};
  width: 100%;
  height: 100px;
  overflow-y: auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const EditIcon = styled.button`
  background-color: #2e7d32;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 5px;
  &:hover {
    background-color: #1b5e20;
  }
`;